import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const PopularRentalItems = () => {
  const [categories, setCategories] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Rental/GetPopularCategoryDetailsForFrontend`
      );

      if (response && response.length > 0) {
        const mappedCategories = response.map((category) => ({
          ...category,
          image: category.imagePath ? `${ImageURL}${category.imagePath}` : null,
        }));
        setCategories(mappedCategories);
      } else {
        setCategories([]);
      }
    } catch (error) {
      setCategories([]);
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (categories?.length) {
      if ($(".services-carousel").length) {
        $(".services-carousel").owlCarousel({
          loop: true,
          margin: 30,
          autoHeight: false,
          autoplay: true,
          autoplayTimeout: 3000,
          dots: false,
          nav: true,
          navText: [
            '<i class="ti-angle-left" aria-hidden="true"></i>',
            '<i class="ti-angle-right" aria-hidden="true"></i>',
          ],
          responsiveClass: true,
          responsive: {
            0: {
              dots: false,
              items: 1,
            },
            600: {
              dots: false,
              items: 2,
            },
            1000: {
              dots: false,
              items: 3,
            },
          },
        });
      }
    }
  }, [JSON.stringify(categories)]);

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <section className="services section-padding">
      <div className="container">
        <div className="row mb-30">
          <div className="col-md-3">
            <div className="sub-title border-bot-light">Discover</div>
          </div>
          <div className="col-md-9">
            <div className="section-title">Popular Rental Items</div>
          </div>
        </div>

        {/* Owl Carousel */}
        <div className="services-carousel owl-theme owl-carousel">
          {categories.map((category, index) => (
            <div key={index} className="item">
              <div className="item-wrap">
                <div className="img">
                  {category.image ? (
                    <img
                      src={category.image}
                      alt={category.categoryName || "Rental Item"}
                    />
                  ) : (
                    <div className="placeholder-image">No Image Available</div>
                  )}
                </div>
                <div className="con">
                  <div className="title-box">
                    <h3>{category.categoryName}</h3>
                  </div>
                  <div className="arrow">
                    <a href={`/rentalitem/${category.categoryID}`}>
                      <span className="ti-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularRentalItems;
